import i18n from './index';

export class GlobalText {
  static completedDate(date: string): string {
    return i18n._translate('Completed %{date}', {
      context: 'A label displaying when a workout is completed along with the date the workout was finished.',
      date,
    });
  }

  static liveDate(date: string): string {
    return i18n._translate('Live %{date}', {
      context:
        'A label displaying when a live workout is scheduled to start with either the date or time. Example: Live 6:00 PM or Live Tuesday 11:00 AM',
      date,
    });
  }

  static startingInTime(time: string): string {
    return i18n._translate('Starting In %{time}', {
      context:
        'A label displaying when a live workout is about to start with an active countdown. Example: Starting In 8:08',
      time,
    });
  }

  static get liveNow(): string {
    return i18n._translate('Live Now', {
      context: 'A label displaying when a workout is currently live and airing real time.',
    });
  }

  static get tryAgain(): string {
    return i18n._translate('Try again', {
      context: 'A button letting the user know to attempt the action another time.',
    });
  }

  static get viewDetails(): string {
    return i18n._translate('View details', {
      context: 'A paragraph describing the action to be performed on a workout card.',
    });
  }

  static numberOfWorkouts(number: string | number): string {
    return i18n._translate('%{number} Workouts', {
      context: 'A label displaying the number of workouts in a series.',
      number,
    });
  }

  static get beginner(): string {
    return i18n._translate('Beginner', {
      context:
        'A "beginner" tag implies that a certain workout or series of workouts was made to appeal to the skill level of an inexperienced athlete.',
    });
  }

  static get intermediate(): string {
    return i18n._translate('Intermediate', {
      context:
        'An "intermediate" tag implies that a certain workout or series of workouts was made to appeal to the skill level of a mid-level athlete.',
    });
  }

  static get advanced(): string {
    return i18n._translate('Advanced', {
      context:
        'An "advanced" tag implies that a certain workout or series of workouts was made to appeal to the skill level of an experienced athlete.',
    });
  }
}
